import Sortable from 'sortablejs';

export default {
  data() {
    return {
      sortableEl: null
    };
  },
  mounted() {
    this.sortableEl = document.querySelector(
      `${this.sortable} > .el-table__body-wrapper > table > tbody`
    );
    if (this.sortableEl) {
      Sortable.create(this.sortableEl, {
        onEnd: evt => {
          this.onSort && this.onSort(evt);
        }
      });
    } else {
      if (this.sortableSync) {
        this.$watch(this.sortableSync, () => {
          if (!this.sortableEl) {
            this.sortableEl = document.querySelector(
              `${this.sortable} > .el-table__body-wrapper > table > tbody`
            );
            if (this.sortableEl) {
              Sortable.create(this.sortableEl, {
                onEnd: evt => {
                  this.onSort && this.onSort(evt);
                }
              });
            }
          }
        });
      }
    }
  }
};
